<template>
  <div class="mk-organisationgalleries row">
      <div
      class="
        px-0
        col-12
        d-flex
        flex-column flex-md-row
        justify-content-start justify-content-md-between
        align-items-md-center align-items-start
      "
    >
      <h3 class="ml-0 mb-0">Artworks</h3>

      <div class="d-flex flex-column flex-md-row">
        <a
          :href="`/admin/organisations/create`"
          @click="$event.target.blur()"
          class="btn btn-success mb-3 mb-md-0 ml-md-3"
          >Download All QR Codes</a
        >

        <a
          :href="`/admin/organisations/create`"
          @click="$event.target.blur()"
          class="btn btn-success mb-3 mb-md-0 ml-md-3"
          >Add New Artwork</a
        >
      </div>
    </div>

    <div class="container-fluid mb-4 px-0">
      <div class="row mx-0">
        <div class="col-12 px-0">
          <div class="organisation-card hf-base-card bg-white">
            <paginated-table
              v-if="organisations.data"
              :tableData="tableData"
              :paginatedData="organisations"
              @pagination-change-page="getOrganisations"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Organisation from "../../models/Organisation";

export default {
  async mounted() {
    this.getOrganisations();
  },
  data() {
    return {
      organisations: {},
      tableData: {
        columns: [
           {
            label: "ID",
            name: "id",
            sortable: true,
          },
          {
            label: "Name",
            name: "name",
            sortable: true,
          },
          {
            label: "Size",
            name: "name",
            sortable: true,
          },
          {
            label: "Creator",
            name: "name",
            sortable: true,
          },
          {
            label: "Comments",
            name: "name",
            sortable: true,
          },
          {
            label: "Status",
            name: "name",
            sortable: true,
          },
          {
            label: "Actions",
            name: "number_artwork",
            sortable: false,
          }
        ],
        edit: false,
        showSearch: true,
        showPerPage: false,
        viewUrl: "/admin/organisations",
      },
    };
  },
  methods: {
    async getOrganisations(
      page = 1,
      sortColumn = null,
      query = null,
      per_page = 15,
      desc = false
    ) {
      let organisations = Organisation.page(page)
        .include('activeExhibitions')
        .limit(per_page);

      if (sortColumn) {
        organisations.orderBy(
          (desc ? "-" : "") + (sortColumn.sort_name || sortColumn.name)
        );
      } else {
        organisations.orderBy("-created_at");
      }

      this.organisations = await organisations.get();
    },
  },
};
</script>
